import get from 'lodash/get'
import * as Sentry from '@sentry/browser'
import { ClientsTrackingClientTypes } from '@homebot/shared-util-quartermaster'

// Requests
import {
  getFavoriteListings,
  postToggleFavoriteListing,
} from '../api/nestready/requests'

// Constants
import { LISTING_FAVORITED_EVENT } from '../constants/client/clientEvents'
import { LISTINGS_FAVORITES } from '../constants/listings'
import {
  TOGGLE_FAVORITE_LISTING,
  FETCH_HOMEBOT_LISTINGS_REQUEST,
  FETCH_HOMEBOT_LISTINGS_SUCCESS,
  FETCH_HOMEBOT_LISTINGS_FAILURE,
} from './actionTypes'

import { SearchListing, ListingDetailsListing } from '../../src/types/listings'
import { trackBuyerActivityMikasa } from './buyer'
import { NEST_READY_HOME_SEARCH } from '../constants/client/clientEventSources'

export const fetchFavoriteListings = customerId => dispatch => {
  const tag = LISTINGS_FAVORITES
  dispatch({ type: FETCH_HOMEBOT_LISTINGS_REQUEST, page: 1, tag })

  getFavoriteListings(customerId)
    .then(resp => {
      const listings = get(resp, 'data.data', [])
      dispatch({
        type: FETCH_HOMEBOT_LISTINGS_SUCCESS,
        page: 1,
        listings,
        tag,
      })
    })
    .catch(error => {
      dispatch({
        type: FETCH_HOMEBOT_LISTINGS_FAILURE,
        tag,
      })
      Sentry.captureException(error)
    })
}

export const setFavoriteListing = ({
  listing,
  isFavorited,
  tag,
  position,
}) => ({
  type: TOGGLE_FAVORITE_LISTING,
  listing,
  isFavorited,
  tag,
  position,
})

type ToggleFavoriteListingParams = {
  listing: ListingDetailsListing | SearchListing
  customerId: string
  position?: number | null
  trackingClient?: ClientsTrackingClientTypes
}

export const toggleFavoriteListing =
  ({
    listing,
    customerId,
    position,
    trackingClient,
  }: ToggleFavoriteListingParams) =>
  dispatch => {
    postToggleFavoriteListing(listing, customerId)
      .then(async resp => {
        const response = get(resp, 'data.data')

        // create client-event and amplitude event
        if (response.isFavorited) {
          trackingClient?.homeFavorited()
          dispatch(
            trackBuyerActivityMikasa({
              eventName: LISTING_FAVORITED_EVENT,
              eventSource: NEST_READY_HOME_SEARCH,
            })
          )
        }

        dispatch(
          setFavoriteListing({
            listing,
            isFavorited: response.isFavorited,
            position,
            tag: LISTINGS_FAVORITES,
          })
        )
      })
      .catch(error => {
        Sentry.captureException(error)
      })
  }
